export default "__VITE_ASSET__C6JCZ2IU__"